import { TDirectMessageDB } from '../../types/db';
import db from './db';
import appStore from '../../store';
import { TNullableAttachment } from '../../types/attachments';
import { TDirectMessage } from '../../types/direct-chat';

class DirectMessageModel implements TDirectMessageDB {
  uuid: string;
  currentUserId: string;
  to: string;
  from: string;
  body: string;
  thread: string;
  stamp: string;
  alertTitle?: string;
  alertStyle?: string;
  alertVital?: 'bpm' | 'systolic' | 'diastolic' | 'cholesterol' | 'temperature' | 'glucose';
  attachment?: TNullableAttachment;
  archivedId?: string;

  constructor({
    uuid,
    to,
    from,
    body,
    stamp,
    alertTitle,
    alertStyle,
    alertVital,
    attachment,
    thread,
  }: TDirectMessage) {
    const currentUserId = appStore.getState().users.currentUser!.id;
    this.uuid = uuid;
    this.to = to;
    this.from = from;
    this.body = body;
    this.stamp = stamp;
    this.alertTitle = alertTitle;
    this.alertStyle = alertStyle;
    this.alertVital = alertVital;
    this.attachment = attachment;
    this.thread = thread;
    this.currentUserId = currentUserId;
  }

  static async getMessagesByThread(thread: string): Promise<TDirectMessageDB[]> {
    const currentUserId = appStore.getState().users.currentUser!.id;
    return await db.directMessages
      .where('[thread+currentUserId]')
      .equals([thread, currentUserId])
      .sortBy('stamp');
  }

  static async bulkSave(messages: TDirectMessageDB[]) {
    try {
      return await db.directMessages.bulkPut(messages);
    } catch (e) {
      console.error('[DB - bulksave err: ]', e);
    }
  }

  async save() {
    const currentUserId = appStore.getState().users.currentUser!.id;
    return await db.directMessages.put({
      currentUserId,
      uuid: this.uuid,
      to: this.to,
      from: this.from,
      body: this.body,
      thread: this.thread,
      stamp: this.stamp,
      alertTitle: this.alertTitle,
      alertStyle: this.alertStyle,
      alertVital: this.alertVital,
      attachment: this.attachment,
      archivedId: this.archivedId,
    });
  }
}

export default DirectMessageModel;
